module.exports = __webpack_public_path__ + "media/images/icons8-gym-0bd1a57e81124d3ca8f68308c4134a67.svg";